<template>
    <dashboard-criticality-card
        title="Dijital Ehliyet"
        :fields="fields"
        :provider="provider"
        :enabled-levels="enabledLevels"
        excel-file-name="Dijital_Ehliyet" />
</template>

<script>
import EmployeeOperationsApi from "@/api/employee-operations";
import DashboardCriticalityCard from "./DashboardCriticalityCard.vue";

export default {
    components: { DashboardCriticalityCard },
    props: {
        enabledLevels: { type: Array, default: null },
    },
    data() {
        return {
            fields: [
                { name: "Personel", key: "EmployeeFullName" },
                { name: "Sicil No", key: "RegistrationCode" },
                { name: "Başlangıç Tarihi", key: "DigitalLicenseValidityStartDateStr" },
                { name: "Bitiş Tarihi", key: "DigitalLicenseValidityEndDateStr" },
                { name: "Kalan Gün", key: "RemainingDate" },
            ],
        };
    },
    methods: {
        provider() {
            return EmployeeOperationsApi.DriverLicenseDashboard();
        },
    },
};
</script>
